<template>
  <div id="app">
    <template v-if="isIndexOf">
      <router-view :style="grayscaleStyle" />
    </template>
    <div v-else class="closeApp">出错啦!404</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isIndexOf: true,
      isGrayscale: false,
    };
  },
  computed: {
    grayscaleStyle() {
      return this.isGrayscale ? { filter: "grayscale(100%)" } : {};
    },
  },
  methods: {
    initData() {
      this.$request("/web/info").then((res) => {
        let result = res.data.data;
        this.isGrayscale = result.blackWhiteShow;
        let ips = result.ips;
        let showXf = result.showXf;
        let flag = result.flag;

        var urlObj = new URL(window.location.href);
        var hostname = urlObj.href;

        const iss = ips.some((item) => hostname.includes(item));
        this.isIndexOf = iss;

        localStorage.setItem("showXf", showXf);
        localStorage.setItem("flag", flag);
      });
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style>
.closeApp {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  letter-spacing: 2px;
}
</style>
